module.exports = __webpack_public_path__ + "static/media/muscle.221c9c0c.svg";